"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropzone = exports.hydrateDataUrl = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dropzone_1 = require("react-dropzone");
const lib_1 = require("../../lib");
const DropzoneBox_1 = require("./DropzoneBox");
function wrapCallback(callback) {
    return (0, react_1.useCallback)(callback, [callback]);
}
function hydrateDataUrl(files, asText = false) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
        if (!FileReader)
            return null;
        const results = files.map((file) => {
            return new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.onload = () => {
                    if (asText)
                        file.text = fileReader.result;
                    else
                        file.dataUrl = fileReader.result;
                    resolve(file);
                };
                asText ? fileReader.readAsText(file) : fileReader.readAsDataURL(file);
            });
        });
        return yield Promise.all(results);
    });
}
exports.hydrateDataUrl = hydrateDataUrl;
const DropzoneComponent = (_a) => {
    var { asText, className, children, fluid, onChange, getOpen } = _a, dropzoneOptions = (0, tslib_1.__rest)(_a, ["asText", "className", "children", "fluid", "onChange", "getOpen"]);
    const onChangeHandler = (0, react_1.useCallback)(onChange, [onChange]);
    const onDropAccepted = (0, react_1.useCallback)(dropzoneOptions.onDropAccepted, [
        dropzoneOptions.onDropAccepted,
    ]);
    const handleDropAccepted = (0, react_1.useCallback)((files, event) => {
        hydrateDataUrl(files, asText).then((dzFiles) => {
            if (onChangeHandler)
                onChangeHandler(dzFiles, event);
            if (onDropAccepted)
                onDropAccepted(dzFiles, event);
        });
    }, [onChangeHandler, onDropAccepted]);
    const { getInputProps, getRootProps, isFocused, isDragActive, isDragAccept, isDragReject, isFileDialogActive, open, } = (0, react_dropzone_1.useDropzone)(Object.assign(Object.assign({}, dropzoneOptions), { onDropAccepted: handleDropAccepted, onDragEnter: wrapCallback(dropzoneOptions.onDragEnter), onDragLeave: wrapCallback(dropzoneOptions.onDragLeave), onDragOver: wrapCallback(dropzoneOptions.onDragOver), onDrop: wrapCallback(dropzoneOptions.onDrop), onDropRejected: wrapCallback(dropzoneOptions.onDropRejected), onFileDialogCancel: wrapCallback(dropzoneOptions.onFileDialogCancel) }));
    (0, react_1.useEffect)(() => {
        if (getOpen) {
            getOpen(open);
        }
    }, []);
    const clsName = (0, lib_1.bem)("dropzone", (0, lib_1.use)(fluid, "--fluid"), (0, lib_1.use)(isFocused, "--focussed"), (0, lib_1.use)(isDragActive, "--drag-active"), (0, lib_1.use)(isDragAccept, "--drag-accepted"), (0, lib_1.use)(isDragReject, "--drag-rejected"), (0, lib_1.use)(isFileDialogActive, "--dialog-active"));
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, getRootProps(), { tabIndex: -1, className: (0, lib_1.classnames)(clsName, className) }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({}, getInputProps(), { className: (0, lib_1.bem)("dropzone__input") }), void 0), children] }), void 0));
};
class Dropzone extends react_1.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(DropzoneComponent, Object.assign({}, this.props), void 0);
    }
}
exports.Dropzone = Dropzone;
Dropzone.Box = DropzoneBox_1.DropzoneBox;
//# sourceMappingURL=Dropzone.js.map